import {ExpensePaymentStatusAPIModel} from 'src/models/api.model'

export interface PaymentState {
  expensePaymentHistory: ExpensePaymentStatusAPIModel[]
}

export const initialPaymentState: PaymentState = {
  expensePaymentHistory: undefined
}
